var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { staticClass: "oblea" }, [
        _c("div", [
          _c("span", { attrs: { id: "producto" } }, [
            _vm._v("Pedido: " + _vm._s(_vm.item.Numero))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "labels",
              attrs: { id: "iconVer" },
              on: { click: _vm.btnVer }
            },
            [
              _c("img", {
                staticClass: "icon-ver",
                attrs: { src: "/dist/icon-ver.png" }
              }),
              _vm._v(" VER  ")
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", { attrs: { id: "fecha" } }, [
          _vm._v(_vm._s(_vm._f("filterFecha")(_vm.item.Fecha)))
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "divImporte" } }, [
          _c("span", { staticClass: "valores", attrs: { id: "importe" } }, [
            _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.item.MontoTotal)))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "labels" }, [_vm._v("TOTAL")])
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "divCantidad" } }, [
          _c("span", { staticClass: "valores", attrs: { id: "cantidad" } }, [
            _vm._v(_vm._s(_vm.item.CantidadItems))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "labels" }, [_vm._v("ITEMS")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74f122a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74f122a6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemPedidoHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-74f122a6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemPedidoHome.vue
// module chunks = 0